"use client";
import React from 'react';
import { Typography, Box, Grid } from '@mui/material';

function LegalActView({ legalActs, onSelectLegalAct }) {
  const groupedActs = legalActs.reduce((acc, act) => {
    const firstLetter = act.title[0].toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(act);
    return acc;
  }, {});

  const sortedLetters = Object.keys(groupedActs).sort();

  // Find the maximum document count for scaling
  const maxDocumentCount = Math.max(...legalActs.map((act) => act.document_count));

  return (
    <Grid container spacing={2}>
      {sortedLetters.map((letter) => (
        <Grid item xs={12} sm={6} md={4} key={letter} style={{ marginBottom: '2rem' }}>
          <Box>
            {/* Letter heading with white color */}
            <Typography variant="h6" style={{ marginBottom: '1rem', color: '#ffffff' }}>
              {letter}
            </Typography>
            {groupedActs[letter].map((act, index) => {
              // Normalize bar width based on max document count
              const barWidth = (act.document_count / maxDocumentCount) * 100;

              return (
                <Box
                  key={index}
                  style={{ marginBottom: '2rem', cursor: 'pointer' }}
                  onClick={() => onSelectLegalAct(act.legal_act_id, act.title)}
                >
                  {/* Title with document count */}
                  <Typography variant="body1" style={{ marginBottom: '0.5rem', color: '#b0b0b0' }}>
                    {act.title}{' '}
                    <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#a0a0a0' }}>
                      {act.document_count}
                    </span>
                  </Typography>

                  {/* Bar chart */}
                  <Box style={{ position: 'relative', height: '20px', display: 'flex', alignItems: 'center' }}>
                    <Box
                      style={{
                        width: `${barWidth}%`,
                        height: '10px',
                        backgroundColor: '#81c784',
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default LegalActView;
